var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7889 21.7736L16.4324 15.4172C17.834 13.782 18.6471 11.6662 18.6471 9.34375C18.6471 4.18223 14.4635 0 9.30333 0C4.14315 0 0 4.18357 0 9.34375C0 14.5039 4.18313 18.6875 9.30333 18.6875C11.6249 18.6875 13.7439 17.8358 15.3768 16.4347L21.7332 22.7911C21.9129 22.9281 22.0971 23 22.2813 23C22.4654 23 22.6491 22.9298 22.7893 22.7894C23.0719 22.5104 23.0719 22.0521 22.7889 21.7736ZM9.34376 17.25C4.94591 17.25 1.43751 13.7012 1.43751 9.34375C1.43751 4.98633 4.94591 1.4375 9.34376 1.4375C13.7416 1.4375 17.25 4.9459 17.25 9.34375C17.25 13.7416 13.7012 17.25 9.34376 17.25Z",
    fill: "#5E06B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.dbe5825cb9a05940fe05aa0177948e09.svg";
export { ForwardRef as ReactComponent };